export const HOSTSERVERPATH= 'https://erpperuapi.smartclic.pe/ClientHub';
export const STORAGE_URL = 'https://smartregistro.s3-us-west-2.amazonaws.com';